<template lang="pug">
    .hidden
        el-form-item(prop="name")
        el-form-item(prop="key")
        template(v-if="!activeTranslation")
            el-form-item(prop="propType.id")
            el-form-item(v-if="propType && propType.key === 'unit'" prop="unit")
            el-form-item(v-if="propType && propType.key === 'date'" prop="detetype")
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';

export default {
    name: 'AllInputFields',
    computed: {
        activeTranslation() {
            if (this.form.translationOrigin) return this.form
        },
        propType() {
            return _.get(this.form, 'propType');
        },
        ...mapGetters({
            form: 'ext_shop_property/form',
        }),
    },
};
</script>
